<script>
/**
 * @overview 七牛上传组件 - pdf预览
 *
 * @author MrRetro
 */

export default {
  name: "AppQiniuPreviewPdf",

  props: {
    src: {
      type: String,
      required: true,
    },
  },

  methods: {
    preview() {
      const message = this.$createElement(
        "iframe",
        {
          domProps: {
            src: this.src,
          },
          style: {
            width: "100%",
            height: "100%",
            border: "none",
            'border-radius': '4px',
          },
          key: Math.floor(Math.random() * (10 ** 10)),
        },
      );

      this.$msgbox({
        title: "pdf在线预览",
        customClass: "app-qiniu__preview-image__dialog",
        message,
        showCancelButton: false,
        showConfirmButton: false,
      })
        .catch(() => {});
    },
  },
};
</script>

<template>
  <span
    :style="{
      'background-image': `url('${src}')`
    }"
    class="app-qiniu__preview-image"
  >
    <div
      :src="src"
      class="img-box-one"
      alt="pdf"/>
  </span>
</template>

<style lang="postcss">
  .img-box-one{
    object-fit: contain;
    position: absolute;
    width: 100%;
    height: 100% !important;
    border: none;
  }
.app-qiniu__preview-image {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: relative;
}

.app-qiniu__preview-image__dialog {
  width: 800px;
}

.app-qiniu__preview-image__dialog .el-message-box__content {
  width: 100%;
  height: 450px;
}

.app-qiniu__preview-image__dialog .el-message-box__message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-position: 0 0, 0 50px;
  background-size: 50px 50px, 50px 51px;
  background-image:
    linear-gradient(
      90deg,
      transparent 0,
      transparent 50%,
      var(--bg-color-default) 50%
    ),
    linear-gradient(
      0deg,
      var(--bg-color-default) 0,
      var(--bg-color-default) 50%,
      white 50%
    );
}
</style>
